// Wrap
export const Wrap = {};
//# sourceMappingURL=wrap.js.map